/* Bibliothèque de modèles — EM-02 (Bible §50.2 · MER-102).
   Class, language, version, sender and last use in one table; the classes
   stay separated in the interface exactly as they are in delivery. Template
   names and classes come from '@/emails' (read-only); the library metadata
   — version, publication state, last send — comes from the seam. */
import { useNavigate } from 'react-router-dom'
import { Button, ErrorState } from '@/ui'
import { TEMPLATES } from '@/emails/templates'
import { useTemplates } from './api'
import { Chargement, Retour } from './parts'

export default function Modeles() {
  const { data, isPending, isError, refetch } = useTemplates()
  const nav = useNavigate()

  if (isPending) return <Chargement />
  if (isError) return (
    <ErrorState what="Impossible de charger la bibliothèque."
      action={<Button variant="primary" size="sm" onClick={() => refetch()}>Réessayer</Button>} />
  )

  /* names/classes are the e-mail inventory’s, never re-authored here */
  const nameOf = (id: string) => TEMPLATES.find(t => t.id === id)?.name
  /* the rows that have a screen of their own reach it — the rest are library
     entries until someone builds their frame (batch 2 ruling, WF-08's lesson) */
  const ECRAN: Record<string, string> = {
    cadeau: '/messages/apercu/cadeau',
    avis: '/messages/apercu/avis',
    'rappel-retour': '/messages/apercu/rappel',
    'revenez-jouer': '/messages/revenez-jouer',
  }

  return (
    <div style={{ display: 'grid', gap: 16, maxWidth: 880 }}>
      <Retour to="/messages?onglet=emails" label="E-mails aux clients" />
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h2 className="t-page" style={{ margin: 0 }}>Bibliothèque de modèles</h2>
        <span style={{ marginLeft: 'auto' }}>
          <Button variant="primary" size="sm" onClick={() => nav('/messages/modeles/studio')}>Nouveau modèle</Button>
        </span>
      </div>

      <div className="tablewrap">
        <table className="tbl">
          <thead>
            <tr><th>Modèle</th><th>Classe</th><th>Langue</th><th>Version</th><th>Dernier envoi</th><th /></tr>
          </thead>
          <tbody>
            {data.rows.map(r => (
              <tr key={r.id}>
                <td><b>{nameOf(r.id) ?? r.name}</b></td>
                <td>{r.classeLabel}</td>
                <td>{r.langue}</td>
                <td>
                  {r.version}{' '}
                  <span className={'pill pill-' + (r.status === 'publiee' ? 'ok' : 'warn')}>
                    {r.status === 'publiee' ? '●' : r.status === 'brouillon' ? '✎' : '◔'} {r.statusLabel}
                  </span>
                </td>
                <td>{r.lastSend}</td>
                <td>{ECRAN[r.id] && <Button size="sm" variant="quiet" onClick={() => nav(ECRAN[r.id])}>Voir</Button>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <p className="f-help" style={{ margin: 0 }}>
        Expéditeur par défaut&nbsp;: {data.sender}, nom d’affichage marchand. Domaine
        marchand&nbsp;: après vérification uniquement, statut honnête.
      </p>
    </div>
  )
}
